import { useDispatch } from 'store/hooks';
import { blotterInitialise } from './actions';

export const useDispatchBlotterInitialise = (widgetKey: string) => {
    const dispatch = useDispatch();
    return () => {
        dispatch(blotterInitialise(widgetKey));
    };
};
